module.exports = __webpack_public_path__ + "img/logorosepetal.2f79c4b0.png";